import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=6ba662fa&scoped=true&"
import script from "./CardPlan.vue?vue&type=script&lang=js&"
export * from "./CardPlan.vue?vue&type=script&lang=js&"
import style0 from "./CardPlan.vue?vue&type=style&index=0&id=6ba662fa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba662fa",
  null
  
)

export default component.exports